import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import {getBanner} from "../service";
import { connect } from "react-redux";
import { State } from "../store/reducer";
import { BannerData } from "../pages/types";
import { bannerAction } from "../store/actions";


interface BannerProps {
    images:Array<Array<BannerData>>,
    location:number
}

interface BannerState  {
    banners:string[]
}

class Banner extends React.Component<BannerProps, BannerState> {

    constructor(props:any){
        super(props);
    }

    componentDidMount() {
        // @ts-ignore
        const { images,location,dispatch } = this.props
        if(!images[location]){
            getBanner({
                location:location || 0
            }).then(res => {
                // console.log(res)
                if(res.code === 1){
                    dispatch(bannerAction({
                        active:location,
                        data:res.data
                    }))
                }
            })
        }
    }

    handleClick(url:string){
        if(/http/.test(url)){
            window.location.href = url
        }
    }

    render() {
        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows:false,
            centerMode:true,
            autoplay:true,
            autoplaySpeed:4000,
            centerPadding:'15px',
        };

        const { images,location } = this.props
        const lists = images[location]

        // console.log(lists)

        if(!lists){
            return  null
        }


        return <div className="homeBanner">
            <Slider {...settings}>
                {
                    // @ts-ignore
                    lists.map((item,index:number) => {
                        return <div key={index} style={{ width:'90%' }}>
                            <div className="pad">
                                <div className="banner-slider" onClick={ () => this.handleClick(item.targetHref) } style={{ backgroundImage:`url(${ item.imgUrl })` }}/>
                            </div>
                        </div>
                    })
                }

            </Slider>
        </div>;
    }
}


export default connect(
    (state:State,ownProps:any) => {
        // console.log(state.banners)
        return { images:state.banners,location:(ownProps.location) as number || 0 }
    }
    // @ts-ignore
)(Banner);
